<template>
    <div>
        <header class="header">
            <div class="left logo">
                <router-link :to="{path:'/main/index'}">
                    <img :src="logoImg" alt="logo" @error="imgError">
                    <span>{{ platform.platform_title }} | {{OsType}}</span>
                </router-link>
            </div>
            <div class="cur_task" v-if="isTaskPath">
                <span>当前任务：</span>
                <div :title="task">{{ task }}</div>
            </div>
            <div class="right">
                <span class="header_person"></span>
                <div class="drop">
					<span @click="toInfo">
						<a>个人中心</a>
					</span>
					<span @click="toIn">
						<a>退出</a>
					</span>
                </div>
            </div>
        </header>
    </div>
</template>
<script>
    import Config from "@/config/index"
    export default {
        name: '',
        data(){
            return {
                base: {
                    show: false,
                    title: "修改密码"
                },
                form:{},
                rules:{
                    oldPwd:[{ required: true, message: '原密码不能为空', trigger: 'blur' }],
                    newPwd:[
                        { required: true, message: '新密码不能为空', trigger: 'blur' },
                        {required: true,pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[A-Z]{1}[a-zA-Z0-9\W_]{7,29}$/,message: '密码格式为由大写字母开头,大小写字母、数字、特殊字符中的至少3种组成8~30位的字符串',trigger: 'blur'}
                    ],
                    newPwd2:[{ required: true, message: '确认不能为空', trigger: 'blur' }]
                },
                logoImg:require("../../assets/image/public/logo.png")
            }
        },
        computed: {
            platform(){
                return this.$store.getters['user/platform']
            },
            OsType(){
                return Config.OsType;
            },
            task(){
                return this.$store.getters['main/task'].task_name;
            },
            isTaskPath(){
                return this.$route.matched[0].meta.module == 'task';
            }
        },
        created(){
            if(this.platform.platform_logo){
                this.logoImg = Config.commAssetUrl+this.platform.platform_logo;
            }
        },
        methods: {
            imgError(){
                this.logoImg = require("../../assets/image/public/logo.png")
            },
			toInfo(){
				this.$router.push({path:"/my/information"})
			},
			toIn(){
				this.$router.push({path:"/sign/in"})
			},
            // resetPwd() {
            //     console.log(Md5)
            //     this.base.show = true;
            // },
            // sure() {
            //     this.$refs['form'].validate(val => {
            //         if (val) {
            //             if (this.form.newPwd != this.form.newPwd2) {
            //                 this.$tip.error("确认密码不一致！");
            //                 return false;
            //             }
            //             let data = {
            //                 oldPwd: Md5(this.form.oldPwd),
            //                 newPwd: Md5(this.form.newPwd),
            //             }
            //             console.log(data)
            //             // this.$store.dispatch("user/resetPwd", data).then(res => {
            //             //     this.$tip.success(res.msg);
            //             //     this.base.show = false;
            //             // })
            //         }
            //     });

            // }
        },
    }
</script>
<style lang='scss' scoped>
	.drop span a {
		color: #1597fc;
		font-size: 12px;	
}
</style>